import { fetchPurchaseMotions } from 'purchase-motions-api/query/purchaseMotions';
import { useEffect, useState } from 'react';
import { PurchaseMotions } from '../types/PurchaseMotion';
export const usePurchaseMotionForAssignability = ({
  isAssignable,
  apiName
}) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [purchaseMotion, setPurchaseMotion] = useState();
  useEffect(() => {
    if (isAssignable === undefined) {
      fetchPurchaseMotions({
        locations: ['TALK_TO_SALES_BUTTON'],
        apiNames: [apiName]
      }).then(response => {
        var _response$locations$T;
        setPurchaseMotion(((_response$locations$T = response.locations['TALK_TO_SALES_BUTTON']) === null || _response$locations$T === void 0 || (_response$locations$T = _response$locations$T.purchaseMotions) === null || _response$locations$T === void 0 || (_response$locations$T = _response$locations$T[apiName]) === null || _response$locations$T === void 0 ? void 0 : _response$locations$T.map(pm => pm.key)[0]) || PurchaseMotions.TALK_TO_SALES_FALLBACK);
        setLoading(false);
      }).catch(e => {
        setError(e);
        setLoading(false);
      });
    } else {
      setPurchaseMotion(isAssignable ? PurchaseMotions.TALK_TO_SALES : PurchaseMotions.TALK_TO_SALES_FALLBACK);
      setLoading(false);
    }
  }, [apiName, isAssignable]);
  return {
    loading,
    error,
    purchaseMotion
  };
};